import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';

const TicketAccessMissing = () => {
    const { i18next } = useAppContext();
    return (
        <div className="flex h-full w-full items-center justify-center">
            <div className="text-center">
                <h2 className="text-lg font-semibold text-gray-800">
                    {i18next.t('tickets.ticket.not_available')}
                </h2>
                <p className="mt-2 text-gray-600">
                    {i18next.t('tickets.ticket.no_access')}
                </p>
            </div>
        </div>
    );
};

export default TicketAccessMissing;
